<!-- src/app/views/prueba-informativa/listado-prueba-informativa/listado-prueba-informativa.component.html -->
<mat-card appearance="outlined" *appRoles="['PruebasInformativa.Listar']">
  <mat-card-header [hidden]="!showHeader">
    <div class="header-nombre-nuevo">
      <h2>Pruebas Informativas</h2>
      <app-button-new (click)="openDialog({ accion: accionesDialog.Agregar})"></app-button-new>
    </div>
  </mat-card-header>

  <!-- Contenido de filtros -->
  <!-- <mat-card-content>
    <form [formGroup]="formFilter">
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Descripción</mat-label>
            <input matInput type="text" formControlName="Descripcion" />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Persona Informante</mat-label>
            <input matInput type="text" formControlName="PersonaInformante" />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Estado de Prueba</mat-label>
            <input matInput type="text" formControlName="EstadoPrueba" />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Domicilio</mat-label>
            <input matInput type="text" formControlName="Domicilio" />
          </mat-form-field>
        </div>
      </div>

      <div class="row" *ngIf="checkedFiltroAvanzado">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Usuario Responsable</mat-label>
            <input matInput type="text" formControlName="UsuarioResponsable" />
          </mat-form-field>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Rango de Fechas Oficio</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input matStartDate placeholder="Fecha Desde" [formControl]="formFilter.get('FechaOficioDesde')">
              <input matEndDate placeholder="Fecha Hasta" [formControl]="formFilter.get('FechaOficioHasta')">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-auto">
          <div style="display: flex; align-items: center; gap: 8px;">
            <app-button-filter-table (click)="aplicarFiltro()"></app-button-filter-table>
            <app-button-filter-table-clear (click)="limpiarFiltro()"></app-button-filter-table-clear>
          </div>
        </div>
        <div class="col-auto">
          <mat-slide-toggle (change)="filtrosAvanzados($event)" color="primary">
            Filtros Avanzados
          </mat-slide-toggle>
        </div>
      </div>
    </form>
  </mat-card-content> -->

  <mat-card-content>
    <mat-divider></mat-divider>
    <ngx-spinner [zIndex]="100" name="spPruebasInformativa" bdColor="rgba(255,255,255,0.8)" size="default"
      color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
    </ngx-spinner>

    <!-- Inicio Contenedor acciones tabla -->
    <div class="contenedor-acciones-tablas">
      <div class="acciones-tabla">
        <!-- Botón de Acciones -->
      </div>
      <app-input-filter-table (filterChange)="applyFilter($event)" *ngIf="data">
      </app-input-filter-table>
    </div>
    <!-- Fin Contenedor acciones tabla -->

    <div *ngIf="data">
      <table class="mat-elevation-z8" mat-table [dataSource]="dataSource" matSort matSortStart="asc">

        <ng-container matColumnDef="descripcion">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Descripción</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let pruebaInformativa">
            <div>
              <strong>{{ pruebaInformativa.descripcion | titlecase }}</strong>
              <div class="text-muted small" *ngIf="pruebaInformativa.observaciones">
                {{ pruebaInformativa?.observaciones }}
              </div>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="personaInformante">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Persona Informante</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let pruebaInformativa">
            <span *ngIf="pruebaInformativa.personaInformante; else sinInformante">
              {{ pruebaInformativa?.personaInformante?.nombreCompleto | titlecase }}
            </span>
            <ng-template #sinInformante>
              <span class="text-muted">Sin informante</span>
            </ng-template>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="domicilio">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Domicilio</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let pruebaInformativa">
            <span *ngIf="pruebaInformativa?.domicilio; else sinDomicilio">
              {{ pruebaInformativa?.domicilio | titlecase }}
            </span>
            <ng-template #sinDomicilio>
              <span class="text-muted">Sin especificar</span>
            </ng-template>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="informaSobre">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Informa Sobre</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let pruebaInformativa">
            <span *ngIf="pruebaInformativa.informaSobre; else sinInfo">
              {{ pruebaInformativa?.informaSobre | slice:0:50 }}{{ pruebaInformativa.informaSobre &&
              pruebaInformativa?.informaSobre.length > 50 ? '...' : '' }}
            </span>
            <ng-template #sinInfo>
              <span class="text-muted">Sin información</span>
            </ng-template>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="estadoPrueba">
          <mat-header-cell *matHeaderCellDef>
            <strong>Estado</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let pruebaInformativa">
            {{pruebaInformativa?.descripcion | titlecase}}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fechaOficioConfronte">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Fecha Oficio</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let pruebaInformativa">
            <span *ngIf="pruebaInformativa?.fechaOficioConfronte; else sinFecha">
              {{ pruebaInformativa?.fechaOficioConfronte | date:'dd/MM/yyyy' }}
            </span>
            <ng-template #sinFecha>
              <span class="text-muted">Sin fecha</span>
            </ng-template>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="usuarioResponsable">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Responsable</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let pruebaInformativa">
            <span *ngIf="pruebaInformativa.usuarioResponsable; else sinResponsable">
              {{ pruebaInformativa.usuarioResponsable.nombreCompleto | titlecase }}
            </span>
            <ng-template #sinResponsable>
              <span class="text-muted">Sin asignar</span>
            </ng-template>
          </mat-cell>
        </ng-container>

        <!-- Accion Column -->
        <ng-container matColumnDef="accion">
          <mat-header-cell *matHeaderCellDef>
            <strong>Acción</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let pruebaInformativa" class="action-link">
            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Menú de acciones">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Ver, entidad: pruebaInformativa })"
                *appRoles="['PruebasInformativa.Ver']">
                <mat-icon>visibility</mat-icon>
                <span>Ver</span>
              </button>
              <button mat-menu-item
                (click)="openDialog({ accion: accionesDialog.Modificar, entidad: pruebaInformativa })"
                *appRoles="['PruebasInformativa.Modificar']">
                <mat-icon>edit</mat-icon>
                <span>Editar</span>
              </button>
              <button mat-menu-item
                (click)="openDialog({ accion: accionesDialog.Eliminar, entidad: pruebaInformativa })"
                *appRoles="['PruebasInformativa.Eliminar']">
                <mat-icon>delete</mat-icon>
                <span>Eliminar</span>
              </button>
            </mat-menu>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row matRipple *matRowDef="let row; columns: displayedColumns"></mat-row>
      </table>

      <mat-paginator showFirstLastButtons class="paginator" *ngIf="data" [pageSize]="20"
        [pageSizeOptions]="[5, 10, 20, 50, 100, 200]">
      </mat-paginator>
    </div>
    <app-sin-datos-para-mostrar [dataSource]="dataSource"></app-sin-datos-para-mostrar>
  </mat-card-content>
</mat-card>
